export default class ServicesPopUp {
  constructor(
    servicesPopUpSelector = '.js-swa-services-popup',
    servicesPopUpCloseSelector = '.js-swa-services-popup-close',
    servicesPopUpHideClass = 'swa-services-popup--hidden'
  ) {
    this.servicesPopUpSelector = servicesPopUpSelector;
    this.servicesPopUpCloseSelector = servicesPopUpCloseSelector;
    this.servicesPopUpHideClass = servicesPopUpHideClass;
    this.boundShowPopup = this.showPopUp.bind(this);
  }

  init() {
    const servicesPopUpCloseButton = document.querySelector(this.servicesPopUpCloseSelector);
    this.servicesPopUpElement = document.querySelector(this.servicesPopUpSelector);

    if (!this.servicesPopUpElement) {
      return;
    }

    // Add event listener for scroll
    window.addEventListener('scroll', this.boundShowPopup, true);

    // Close pop-up on click
    servicesPopUpCloseButton.addEventListener('click', (e) => {
      this.servicesPopUpElement.classList.add(this.servicesPopUpHideClass);
      // Since clicking on the pop-up area will open the dialog, this is needed for the X to close it
      e.stopPropagation();
    });
  }

  showPopUp() {
    const promoPopupElement = document.querySelector('.swa-promo');

    // Remove the scroll listener after the page was scrolled
    window.removeEventListener('scroll', this.boundShowPopup, true);

    // The pop-up should appear after the delay
    // "data-delay-popup" value will be choosed in Hybris (backoffice), but here in PL we will use delayPopupTime in jsons
    setTimeout(() => {
      // Removed hidden class
      this.servicesPopUpElement.classList.remove(this.servicesPopUpHideClass);

      // Update the bottom for services popup if the promotional popup was already closed
      if (promoPopupElement) {
        if (promoPopupElement.classList.contains('swa-hidden')) {
          this.servicesPopUpElement.style.bottom = '35px';
        }
      }

      // When services popup is shown after a newsletter popup is in the page:
      // Adjust the bottom for services popup depending of the newsletter popup
      // !!! The case when services popup is shown before the newsletter popup is visible on the page is handled in hybris (acc.newsletterpopup.js)
      const nlPopupElement = document.querySelector('.swa-sc-nl-popup');
      if (nlPopupElement) {
        if (nlPopupElement.classList.contains('swa-hidden') || nlPopupElement.classList.contains('swa-sc-nl-popup--open')) {
          this.servicesPopUpElement.style.bottom = '35px'; //reset services popup to initial bottom value if newsletter popup is not on the page
        } else {
          this.adjustPosition(this.servicesPopUpElement, nlPopupElement); //adjust services popup bottom in order to pe placed on top of the newsletter popup
        }
      }
    }, this.servicesPopUpElement.dataset.delayPopup * 1000);
  }

  adjustPosition(servicePopupElement, nlPopupElement) {
    const servicePopupBottomValue = parseInt(getComputedStyle(servicePopupElement).getPropertyValue('bottom'));
    const nlPopupBottomValue = parseInt(getComputedStyle(nlPopupElement).getPropertyValue('bottom'));

    this.servicesPopUpElement.style.bottom = servicePopupBottomValue + nlPopupElement.offsetHeight + nlPopupBottomValue + 'px';
  }
}
